import React, { useEffect, useState } from "react"
import missingImage from "../../public/images/image-missing.png"

const ImageWithLoadingState = ({
  src,
  alt = "",
  style,
  onLoad,
  onError,
  ...props
}) => {
  const [loadedSrc, setLoadedSrc] = useState("")
  const [failedDisplaySrc, setFailedDisplaySrc] = useState("")
  const displayedSrc = loadedSrc || missingImage.src

  useEffect(() => {
    if (!src) return

    // Keep the bundled placeholder visible while the requested image loads.
    const image = new Image()
    const failedSources = new Set()
    image.onload = () => setLoadedSrc(image.src)
    image.onerror = event => {
      const failedSrc = image.currentSrc || image.src
      if (failedSources.has(failedSrc)) return
      failedSources.add(failedSrc)
      onError?.(event)
    }
    image.src = src

    if (image.complete && image.naturalWidth > 0) {
      setLoadedSrc(image.src)
    }

    return () => {
      image.onload = null
      image.onerror = null
    }
  }, [])

  return (
    <img
      {...props}
      src={displayedSrc}
      alt={alt}
      style={{
        ...style,
        visibility:
          failedDisplaySrc === displayedSrc ? "hidden" : style?.visibility,
      }}
      onLoad={event => {
        if (loadedSrc) onLoad?.(event)
      }}
      onError={event => {
        const failedSrc = displayedSrc

        // Only hide the bundled placeholder when it cannot be rendered. If a
        // product image fails after loading, make the placeholder visible
        // again instead of carrying the inline hidden style over to it.
        const isPlaceholder = failedSrc === missingImage.src
        event.currentTarget.style.visibility = isPlaceholder
          ? "hidden"
          : style?.visibility || ""
        setFailedDisplaySrc(isPlaceholder ? displayedSrc : "")
        setLoadedSrc("")
      }}
    />
  )
}

// Remount before a changed source can inherit the previous image's visibility.
const ProductTileImage = props => (
  <ImageWithLoadingState key={props.src || ""} {...props} />
)

export default ProductTileImage
